function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 1.901A8.099 8.099 0 1010 18.1 8.099 8.099 0 0010 1.9zM0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10z",
  fill: "params(fill) #211FAB"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.295 8.295H10l.95.95v4.33h.754v1.9H10l-.951-.95v-4.329h-.754v-1.9z",
  fill: "params(fill) #211FAB"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.87 5.098h1.884v1.886H8.87V5.098z",
  fill: "params(fill) #211FAB"
});
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}
export default SvgInfo;